import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    .use(initReactI18next).init({
        lng: 'en', // Default language
        fallbackLng: ['en', 'vi'],
        saveMissing: true,
        interpolation: {
            escapeValue: false, // React already escapes data
        },
        backend: {
            loadPath: '/locales/{{lng}}/translations.json'
        }
    });
    
export default i18n;